import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { GerarRenachSemPcadRequest, Types } from './types';

// ACTIONS
import {
	gerarRenachSemPcadSuccess,
	gerarRenachSemPcadFailure,
} from './actions';

function* gerarRenach(request: ReducerAction) {
	const { payload }: { payload: GerarRenachSemPcadRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`sockets/${CHANNEL}/gerar-renach`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(gerarRenachSemPcadSuccess({ response, request: payload }));
	} else if (response.error) {
		yield put(gerarRenachSemPcadFailure(response.error));
	}
}

export default all([
	takeLatest(Types.GERAR_RENACH_SEM_PCAD_REQUEST, gerarRenach),
]);
